// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-group-checkbox input[type=checkbox]:disabled+label[data-v-57b5ef96]{color:#999}[data-v-57b5ef96] hr.payment-form-hr{margin-top:25px;margin-bottom:25px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
